const Role = Object.freeze({
  Admin:"Admin",
 Employee: "Employee",
});

export default Role;
